import { CustomImage, errorDialog, Text } from '@src/components';
import iconSuccess from '@src/assets/icons/icon-success.svg';
import iconPrint from '@src/assets/icons/icon-print.svg';
import iconDateRed from '@src/assets/icons/icon-datepicker-red.svg';
import iconWarning from '@src/assets/icons/icon-warning-orange.svg';
import { Button } from 'antd';
import 'swiper/css/bundle';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import React, { useCallback, useEffect, useMemo } from 'react';
import reportsServices from '@src/services/reports.services';
import { useDispatch, useSelector } from 'react-redux';
import { previewDownload } from '@src/utils/utils';
import '@src/styles/cardOrder/cardCompleted.scss';
import { getLoadBalanceForThanksPage } from '@src/store/slice/balanceUploadSlice';
import '@src/styles/balanceUpload/wireTransferCars.scss';
import EftWireTransferCards from '@src/pages/ticketRestaurant/balanceUpload/payment/EftWireTransferCards';
import { setPayLaterDayForThanksPage } from '@src/store/slice/mobilExpressSlice';
import { useHistory } from 'react-router-dom';
import iconInfo from '@src/assets/icons/icon-info.svg';
import PropTypes from 'prop-types';

export const ItemCardImage = ({ item }) => {
  const Icon = useMemo(() => {
    if (item?.isCalendar) {
      return iconDateRed;
    } else if (item?.isInfo) {
      return iconInfo;
    } else {
      return iconWarning;
    }
  }, [item]);
  return (
    <div className="item-card-image">
      <CustomImage src={Icon} />
    </div>
  );
};

ItemCardImage.propTypes = {
  item: PropTypes.any,
};

const Completed = () => {
  const { currentLoadBalance, thanksPageBalanceUploadTextList } = useSelector(
    (state) => state?.balanceUpload,
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const redirectToHomePage = useCallback(() => {
    history.push('/dashboard');
  }, [dispatch]);

  useEffect(async () => {
    if (!currentLoadBalance) return;
    await dispatch(
      getLoadBalanceForThanksPage({ id: currentLoadBalance?.id, vouId: currentLoadBalance.vouId }),
    );
    await dispatch(setPayLaterDayForThanksPage(null));
  }, [currentLoadBalance]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pdfDownload = useCallback(async () => {
    try {
      const blob = await reportsServices.getBalanceOrderReport({ orderId: currentLoadBalance?.id });
      await previewDownload(blob);
    } catch (error) {
      errorDialog({
        title: <Text t="error" />,
        message: error?.statusText,
      });
    }
  }, [currentLoadBalance]);

  return (
    <div className="card-order-completed-content">
      <div className="success-order-header-content">
        <CustomImage src={iconSuccess} />
        <h1>{thanksPageBalanceUploadTextList?.title}</h1>
        <h5>
          <div
            dangerouslySetInnerHTML={{ __html: thanksPageBalanceUploadTextList?.shortMessage }}
          />
        </h5>
        {thanksPageBalanceUploadTextList?.longMessage ? (
          <p dangerouslySetInnerHTML={{ __html: thanksPageBalanceUploadTextList?.longMessage }} />
        ) : null}

        <div className="description-list">
          {thanksPageBalanceUploadTextList?.messageList &&
            thanksPageBalanceUploadTextList?.messageList.map((item, index) => {
              return (
                <p key={item.message}>
                  <ItemCardImage item={item} />
                  <div
                    className={'message-list-item'}
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  />
                </p>
              );
            })}
        </div>
      </div>
      <div className="footer-content">
        <Button
          id="redirect"
          data-testid="redirect"
          onClick={redirectToHomePage}
          className="footer-content-button"
        >
          <span>
            <Text t="returnToHomePage" />
          </span>
        </Button>
      </div>
      {thanksPageBalanceUploadTextList?.ibanShow && (
        <div className="card-order-etfWireTransferCards">
          <EftWireTransferCards type={'balance'} finishPage={true} />
        </div>
      )}

      <div className="footer-content">
        <Button id="balanceUpload-completed-btn-ghost" className="btn-ghost" onClick={pdfDownload}>
          <CustomImage src={iconPrint} />
          <span>
            <Text t="orderPrinter" />
          </span>
        </Button>
        <Button
          id="balanceUpload-completed-btn-orange"
          className="btn-orange"
          style={{ display: 'none' }}
        >
          <span>
            <Text t="regularInstall" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default Completed;
